import {AnyAction} from "redux";
import {SET_DRAGGING_POWER_SOURCE} from "../actions/action";
import {IPowerSource} from "../../data/data";

export interface Point
{
    x: number;
    y: number;
}

export const getDraggingPowerSource = (state) => state.draggingPowerSource;
export const getDraggingOrigin = (state) => state.draggingOrigin;


/**
 * set the power source being dragged
 */
export function draggingPowerSource(state: IPowerSource = null, action: AnyAction) : IPowerSource
{
    switch (action.type)
    {
        case SET_DRAGGING_POWER_SOURCE:
        {
            const {payload} = action;
            const {power_source} = payload;

            return power_source;
        }

        default:

            return state;
    }
}


/**
 * set the dragging power source origin
 */
export function draggingOrigin(state: Point = null, action: AnyAction) : Point
{
    switch (action.type)
    {
        case SET_DRAGGING_POWER_SOURCE:
        {
            const {payload} = action;
            const {ox:x, oy:y} = payload;

            return {x, y};
        }

        default:

            return state;
    }
}


// WEBPACK FOOTER //
// ./src/ts/store/reducers/draggingPowerSource.ts